/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Favorites_No_FavoritesInputs */



/**
* | output |
* | --- |
* | "No references linked yet." |
*
* @param {Project_Favorites_No_FavoritesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_favorites_no_favorites = /** @type {((inputs?: Project_Favorites_No_FavoritesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Favorites_No_FavoritesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Referenzen verknüpft.")
	return /** @type {LocalizedString} */ ("No references linked yet.")
});